var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "shareShopIcon",
      staticClass: "shareShopIconMain",
      style: "opacity: " + (_vm.keepPress ? 1 : 0.6)
    },
    [
      _c("img", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: {
          src:
            _vm.getShopFoodMarketHostUrl() + "static/images/product/share.png"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }